// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"794a3a6a","6850":"4594675c"}[chunkId] + ".chunk.css";
};